import DonorDetails from "./DonorDetails";

export const UPDATE_DONOR_DETAILS = "UPDATE_DONOR_DETAILS";

export const updateDonorDetails = (donorDetails: DonorDetails) => {
    return {
        type: UPDATE_DONOR_DETAILS,
        data: donorDetails
    }
}